import { ReactNode } from "react";

export const LinkText = ({children}: {children: ReactNode | ReactNode[]}) => {
  return (<span className="font-medium text-brandPrimary dark:text-primary-600 hover:underline">{children}</span>);
}

